import React from "react";
import { forEach } from "lodash";

import { FileProps } from "@/components/FilesUpload/types";
import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContext } from "@/contexts/QREditorContext";
import { isFileAblob, onBindThemePicker } from "@/utils/qrEditorHelper";
import { applyQRFormDefaultValues, onBindClick } from "@/utils/formHelper";

import { qrImagesValidation } from "@/utils/validators/qr-images";

import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QRImagesProps } from "./types";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export const QRImages = ({ data }: QRImagesProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"image">>(QREditorContext);

  const [qrImageData, setQrImageData] = React.useState<QRProps<"image">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataImagesWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);
  const omittedValues = React.useCallback(() => {
    const values = [];
    forEach(qrData.data.imageUrls, (image, idx) => {
      isFileAblob(image.url) && values.push(`data.imageUrls[${idx}].url`);
    });

    return ["data.file", ...values];
  }, [qrData.data.imageUrls]);

  onBindThemePicker(dataImagesWithDefaultValues, "qrImagesThemePicker", omittedValues());

  onBindClick(dataImagesWithDefaultValues, "imageUrls", (files: FileProps[]) => {
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          imageUrls: files,
        },
      },
      omittedValues()
    );
  });

  const onUpdateState = ({ field, value }) => {
    if (field === "file" || field == "") return;
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      omittedValues()
    );
  };

  React.useEffect(() => {
    setQrImageData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrImageData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-images">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataImagesWithDefaultValues}
        schema={qrImagesValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
